export default __webpack_public_path__ + "static/media/Flag_of_Samoa.20dfa6e5.svg";